import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import {
  Lock, Sparkles, CheckCircle, Zap, Shield, FileText, Camera
} from 'lucide-react';

const TrialPaywall = ({ isOpen, onClose, reason, actionType }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    navigate('/pricing');
    onClose();
  };

  const getMessage = () => {
    if (reason === 'time') {
      return "Votre période d'essai de 7 jours est terminée.";
    }
    if (reason === 'actions') {
      return "Vous avez utilisé vos 10 actions gratuites.";
    }
    return "Votre essai gratuit est terminé.";
  };

  const getActionLabel = () => {
    const labels = {
      'invoice_create': 'créer des factures',
      'scan_upload': 'scanner des documents',
      'ppf_simulation': 'simuler l\'envoi PPF/PDP',
      'pdf_export': 'exporter en PDF',
      'facturx_export': 'exporter en Factur-X'
    };
    return labels[actionType] || 'utiliser cette fonctionnalité';
  };

  const proFeatures = [
    { icon: FileText, text: '100 factures / mois' },
    { icon: Camera, text: 'Scanner IA illimité' },
    { icon: Shield, text: 'Simulation PPF/PDP' },
    { icon: Zap, text: 'Export Factur-X conforme' },
  ];

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader className="text-center">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-amber-100 to-orange-100 flex items-center justify-center mx-auto mb-4">
            <Lock className="h-8 w-8 text-amber-600" />
          </div>
          <DialogTitle className="text-xl">
            Passez à Pro pour continuer
          </DialogTitle>
          <DialogDescription className="text-center">
            {getMessage()}
            <br />
            <span className="text-slate-600">
              Passez à Pro pour {getActionLabel()} sans limite.
            </span>
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6 py-4">
          {/* Pro Plan Features */}
          <div className="bg-gradient-to-br from-emerald-50 to-lime-50 rounded-lg p-4 border border-emerald-100">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center space-x-2">
                <Badge className="bg-emerald-600">Recommandé</Badge>
                <span className="font-semibold text-slate-900">Plan Pro</span>
              </div>
              <div className="text-right">
                <span className="text-2xl font-bold text-slate-900">29€</span>
                <span className="text-slate-500 text-sm">/mois</span>
              </div>
            </div>
            <div className="space-y-2">
              {proFeatures.map((feature, idx) => {
                const Icon = feature.icon;
                return (
                  <div key={idx} className="flex items-center space-x-2 text-sm">
                    <CheckCircle className="h-4 w-4 text-emerald-500" />
                    <span className="text-slate-700">{feature.text}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Actions */}
          <div className="space-y-3">
            <Button 
              className="w-full bg-emerald-600 hover:bg-emerald-700 h-11"
              onClick={handleUpgrade}
            >
              <Sparkles className="h-4 w-4 mr-2" />
              Passer à Pro maintenant
            </Button>
            <Button 
              variant="ghost"
              className="w-full text-slate-500"
              onClick={onClose}
            >
              Plus tard
            </Button>
          </div>

          {/* Policy notice */}
          <p className="text-center text-xs text-slate-500">
            Essai gratuit sans engagement • Aucun remboursement après activation de l'abonnement
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TrialPaywall;
